import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({ name: "BookingSearch" })
export default class BookingSearch extends Vue {

    @Prop() readonly destination: string;
    @Prop() readonly language: string;


    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://tpwgt.com/content?trs=425744&shmarker=634075.634075&locale=" + this.language + "&default_direction=" + this.destination + "&sustainable=false&deals=false&border_radius=30&plain=false&powered_by=true&promo_id=2693&campaign_id=84");
        document.querySelector("#BookingSearch").appendChild(recaptchaScript);
    }
};